import Swal from "sweetalert2";
import firebase from "../config/global-variables";

//GET EVIDENCES
export const getLastPanicMessage = async (idCompany) => {
  try {
    const url = `https://us-central1-${firebase.nameProyectFirebase}.cloudfunctions.net/app/api/GetLastPanicMessage`;
    // const url = `https://us-central1-bluewayqa.cloudfunctions.net/app/api/GetLastPanicMessage`;
    const optionsRequest = {
      timeout: 10000,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        idCompany: idCompany 
      }),
      //mode:'no-cors'
    };

    const response = await fetch(url, optionsRequest);
    const data = await response.json();
    const parseData = JSON.parse(data);
    const { Data } = parseData;
    return Data;
  } catch (error) {
    console.log("getLastPanicMessage. Se presentó el error=>" + error);
    // console.log("GetLastPanicMessage =>", []);
    // swalMessagepop();
    return [];
  }
};

const swalMessagepop = (message = "") => {
    Swal.fire({
      title: "Advertencia",
      text:
        message === ""
          ? "No se pudo obtener la información del último mensaje de alerta, inténtelo más tardes."
          : message,
      icon: "warning",
      confirmButtonText: "Ok",
    });
  };
  